// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip-box{padding:10px}", "",{"version":3,"sources":["webpack://src/components/charts/LineChartComponent.vue"],"names":[],"mappings":"AAAA,aAAa,YAAY","sourcesContent":[".tooltip-box{padding:10px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
